import {X9Content, X9ContentSnapshot} from '../../../../domain';
import {FlashcardsModel} from '../flashcard/models';
import {flashcardsUtils} from '../flashcard/utils';
import {GapFillingModel} from '../gap-filling/models';
import {gapFillingUtils} from '../gap-filling/utils';
import {GroupingExerciseModel} from '../grouping-exercise/models';
import {groupingExerciseUtils} from '../grouping-exercise/utils';
import {MQMatchingQuestion} from '../matching-question/models';
import {matchingQuestionUtils} from '../matching-question/utils';
import {McqModel} from '../mcq/models';
import {mcqUtils} from '../mcq/utils';
import {InlineOpenEndedQuestionModel} from '../open-ended-question-inline/models';
import {openEndedQuestionInlineUtils} from '../open-ended-question-inline/utils';
import {openEndedQuestionUtils} from '../open-ended-question/utils';
import {SelectQuestionModel} from '../select-question/models';
import {selectQuestionUtils} from '../select-question/utils';
import {SlideShowModel} from '../slideshow/models';
import {slideshowUtils} from '../slideshow/utils';
import {syncedAudioUtils} from '../synced-audio/classroom/utils';
import {SyncedAudioModel} from '../synced-audio/models';
import {syncedVideoUtils} from '../synced-video/classroom/utils';
import {SyncedVideoModel} from '../synced-video/models';
import {X9ContentStateStore} from './X9ContentStateStore';

function setInitialState(store: X9ContentStateStore,
                         x9: X9Content | X9ContentSnapshot,
                         override: boolean): void {
  if (!override)
    if (store.getContentState(x9.Id) !== null)
      return;

  switch (x9.ContentType) {
    case 'matching-question': {
      const model = JSON.parse(x9.Contents) as MQMatchingQuestion;
      const state = matchingQuestionUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'select-question': {
      const model = JSON.parse(x9.Contents) as SelectQuestionModel;
      const state = selectQuestionUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'gap-filling': {
      const model = JSON.parse(x9.Contents) as GapFillingModel;
      const state = gapFillingUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'multiple-choice-question': {
      const model = JSON.parse(x9.Contents) as McqModel;
      const state = mcqUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'grouping-exercise': {
      const model = JSON.parse(x9.Contents) as GroupingExerciseModel;
      const state = groupingExerciseUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'flashcards': {
      const model = JSON.parse(x9.Contents) as FlashcardsModel;
      const state = flashcardsUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'slideshow': {
      const model = JSON.parse(x9.Contents) as SlideShowModel;
      const state = slideshowUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'open-ended-question': {
      const state = openEndedQuestionUtils.initialState();
      store.setContentState(x9.Id, state);
      break;
    }
    case 'open-ended-question-inline': {
      const model = JSON.parse(x9.Contents) as InlineOpenEndedQuestionModel;
      const state = openEndedQuestionInlineUtils.initialState(model);
      store.setContentState(x9.Id, state);
      break;
    }
    case 'synced-audio': {
      const model = JSON.parse(x9.Contents) as SyncedAudioModel;
      const state = syncedAudioUtils.initialState(model);
      store.setContentState(x9.Id, state);
      const playCommand = syncedAudioUtils.initialPlayState(model);
      store.setScopedContentState(x9.Id, 'command', playCommand);
      break;
    }
    case 'synced-video': {
      const model = JSON.parse(x9.Contents) as SyncedVideoModel;
      const state = syncedVideoUtils.initialState(model);
      store.setContentState(x9.Id, state);
      const playCommand = syncedVideoUtils.initialPlayState(model);
      store.setScopedContentState(x9.Id, 'command', playCommand);
      break;
    }
  }
}

export function initializeX9State(store: X9ContentStateStore,
                                  x9: X9Content | X9ContentSnapshot) {
  setInitialState(store, x9, false);
}

function resetX9State(store: X9ContentStateStore,
                      x9: X9Content | X9ContentSnapshot) {
  setInitialState(store, x9, true);
}

class X9ClassroomHelperClass {
  initState = initializeX9State;
  resetState = resetX9State;
}

export const x9ClassroomHelper = new X9ClassroomHelperClass();
